import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import { DIRECTORS } from "@/data/content";

export default function Directors() {
  return (
    <>
      <PageHeader
        eyebrow="Leadership"
        title="Directors"
        description="The directors of Louisiana Ducks guide the organization's mission — developing youth athletes on and off the field."
        testid="directors-header"
      />
      <section className="pt-6 pb-14 sm:pb-20 bg-[#0A0A0A]" data-testid="directors-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-testid="directors-grid">
            {DIRECTORS.map((director, i) => (
              <Reveal key={director.name || director.role} delay={(i % 2) * 0.1}>
                <div
                  className={`group bg-[#111111] border overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-[#FEE123]/60 ${
                    director.name ? "border-[#FEE123]/40" : "border-[#333333]"
                  }`}
                  data-testid={`director-card-${i}`}
                >
                  {director.photo ? (
                    <img
                      src={director.photo}
                      alt={director.name}
                      className="w-full aspect-square object-cover"
                      data-testid={`director-photo-${i}`}
                    />
                  ) : (
                    <div className="w-full aspect-square flex items-center justify-center bg-[#0F4D22] font-display text-8xl text-[#FEE123]">
                      {(director.name || director.role).split(" ").map((w) => w[0]).slice(0, 2).join("")}
                    </div>
                  )}
                  <div className="p-7">
                    {director.name && (
                      <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#FEE123]">{director.role}</p>
                    )}
                    <h3 className="mt-1 text-2xl font-bold uppercase tracking-wide text-white">
                      {director.name || director.role}
                    </h3>
                    <p className="mt-2 text-sm text-gray-400 leading-relaxed">{director.bio || director.focus}</p>
                    {!director.name && (
                      <p className="mt-3 text-xs uppercase tracking-widest text-gray-500 italic">Name &amp; bio to be announced</p>
                    )}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
